module.exports = __webpack_public_path__ + "img/systems.06271def.png";